/**
 * Constantes del webhook externo de n8n para procesar CIF.
 *
 * La URL se construye desde `environment.cifEndpoint`; el header de
 * autenticación `x-api-key` se inyecta desde `environment.cifApiKey`.
 */

export const CIF_API_KEY_HEADER = 'x-api-key';
export const CIF_FILE_FIELD = 'data';
